import WaveSurfer from 'wavesurfer.js';
import RecordPlugin from '/node_modules/wavesurfer.js/dist/plugins/record.esm.js';
import { ConvertToPersianNumbers } from './utils.js';

const createRecorder = (containerId) => {
  let wavesurfer, record;
  let scrollingWaveform = true;

  let containerSelector = '#recorder-container-' + containerId;
  let recorderContainer = document.querySelector(containerSelector);
  let mic = document.querySelector(containerSelector + ' .mic');
  let preview = document.querySelector(containerSelector + ' .preview');

  const previewControlButton = document.querySelector(
    containerSelector + ' .preview-control-button',
  );

  const createWaveSurfer = () => {
    // Create an instance of WaveSurfer
    if (wavesurfer) {
      wavesurfer.destroy();
    }
    wavesurfer = WaveSurfer.create({
      container: mic,
      height: 24,
      splitChannels: false,
      normalize: true,
      waveColor: '#8B8B8B',
      progressColor: '#48A700',
      cursorColor: '#ddd5e9',
      cursorWidth: 0,
      barWidth: 2,
      barGap: 4,
      barRadius: 10,
      barHeight: null,
      fillParent: true,
      autoplay: false,
      interact: true,
      dragToSeek: false,
      hideScrollbar: true,
      audioRate: 1,
      autoScroll: true,
      autoCenter: true,
      sampleRate: 4000,
    });

    // Initialize the Record plugin
    record = wavesurfer.registerPlugin(
      RecordPlugin.create({ scrollingWaveform, renderRecordedAudio: true }),
    );
    // Render recorded audio
    record.on('record-end', (blob) => {
      const recordedUrl = URL.createObjectURL(blob);
      // Create wavesurfer from the recorded audio
      const wavesurfer = WaveSurfer.create({
        container: preview,
        height: 24,
        splitChannels: false,
        normalize: true,
        waveColor: '#8B8B8B',
        progressColor: '#48A700',
        cursorColor: '#ddd5e9',
        cursorWidth: 0,
        barWidth: 2,
        barGap: 4,
        barRadius: 10,
        barHeight: 24,
        fillParent: true,
        autoplay: false,
        interact: true,
        dragToSeek: true,
        hideScrollbar: true,
        audioRate: 1,
        autoScroll: true,
        autoCenter: true,
        sampleRate: 4000,
        url: recordedUrl,
      });

      wavesurfer.on('timeupdate', (currentTime) => {
        updateProgress(currentTime * 1000);
      });
      // Play button

      const playIcon = document.querySelector(
        containerSelector + ' .recorder-play-icon',
      );

      const pauseIcon = document.querySelector(
        containerSelector + ' .recorder-pause-icon',
      );
      previewControlButton.onclick = () => wavesurfer.playPause();
      wavesurfer.on('pause', () => {
        playIcon.classList.remove('hidden');
        pauseIcon.classList.add('hidden');
      });
      wavesurfer.on('play', () => {
        playIcon.classList.add('hidden');
        pauseIcon.classList.remove('hidden');
      });

      document.dispatchEvent(
        new CustomEvent(containerId + '-recorder-record-ended', {
          detail: blob,
        }),
      );
    });

    record.on('record-progress', (time) => {
      updateProgress(time);
    });
  };
  const progress = document.querySelector(
    containerSelector + ' .recorder-progress',
  );
  const updateProgress = (time) => {
    // time will be in milliseconds, convert it to mm:ss format
    const formattedTime = [
      Math.floor((time % 3600000) / 60000), // minutes
      Math.floor((time % 60000) / 1000), // seconds
    ]
      .map((v) => (v < 10 ? '0' + v : v))
      .join(':');
    progress.textContent = ConvertToPersianNumbers(formattedTime);
  };

  const hideMice = () => {
    mic.classList.add('hidden');
  };

  const showMice = () => {
    mic.classList.remove('hidden');
  };

  const hidePreview = () => {
    preview.classList.add('hidden');
  };
  const showPreview = () => {
    preview.classList.remove('hidden');
  };

  const stopButton = document.querySelector(
    containerSelector + ' .recorder-stop-button',
  );

  stopButton.onclick = () => {
    if (record.isRecording() || record.isPaused()) {
      record.stopRecording();
      hideMice();
      showPreview();
      stopButton.classList.add('hidden');
      previewControlButton.classList.remove('hidden');
    }
  };

  document.addEventListener(
    containerId + '-recorder-record-voice',
    async () => {
      let hasMicrophonePermission = true;
      if (navigator.permissions) {
        try {
          const permissionStatus = await navigator.permissions.query({
            name: 'microphone',
          });
          hasMicrophonePermission = permissionStatus.state !== 'denied';
        } catch {}
      }
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        hasMicrophonePermission = false;
      } else {
        try {
          if (
            !(await navigator.mediaDevices.enumerateDevices()).some(
              ({ kind }) => kind === 'audioinput',
            )
          ) {
            hasMicrophonePermission = false;
          }
        } catch {}
      }
      if (hasMicrophonePermission) {
        // reset the wavesurfer instance
        record.startRecording().then(() => {
          recorderContainer.classList.remove('hidden');
          preview.replaceChildren();
          stopButton.classList.remove('hidden');
          previewControlButton.classList.add('hidden');
          showMice();
          hidePreview();
          document.dispatchEvent(
            new CustomEvent(containerId + '-recorder-record-started'),
          );
        });
      } else {
        Livewire.dispatch('show-toast', {
          data: {
            text: 'برای ضبط صدا، باید دسترسی صدا را از طریق تنظیمات مرورگر خود فعال کنید.',
            status: 'error',
          },
        });
      }
    },
  );

  document.addEventListener(
    containerId + '-recorder-finish-record-voice',
    () => {
      recorderContainer.classList.add('hidden');
      preview.replaceChildren();
      createWaveSurfer();
    },
  );

  const deleteButton = document.querySelector(
    containerSelector + ' .delete-button',
  );
  deleteButton.onclick = () => {
    updateProgress(0);
    if (record.isRecording() || record.isPaused()) {
      record.stopRecording();
    }
    preview.replaceChildren();
    recorderContainer.classList.add('hidden');
    stopButton.classList.remove('hidden');
    previewControlButton.classList.add('hidden');
    createWaveSurfer();

    document.dispatchEvent(
      new CustomEvent(containerId + '-recorder-record-cancelled'),
    );
  };
  createWaveSurfer();
};

window.createRecorder = createRecorder;
